import React from "react";
import { Cell, PieChart, Pie, Tooltip } from "recharts";

const colors = [
  "#0B425D",
  "#53B7E8",
  "#007AB5",
  "#F3893D",
  "#6369D1",
  "#72D798",
  "#F36464",
];

const CustomTooltip = ({ active, showCount = true, payload }) => {
  if (active) {
    const activePayload = payload[0].payload;
    return (
      <div
        className="custom-tooltip"
        style={{ padding: "6px", backgroundColor: "black" }}
      >
        <p className="label">
          {showCount
            ? activePayload.value
            : `${activePayload.percentageValue}%`}
        </p>
      </div>
    );
  }

  return null;
};

export default function MetricsPieChart({ data = [], showLabel = false }) {
  const noDataValues = data.every((d) => !d.value);

  return (
    <div className="metrics-pie-chart-container flex flex-align-center">
      {noDataValues ? (
        <div
          className="recharts-wrapper"
          style={{ width: "140px", height: "168px", position: "relative" }}
        >
          <img
            alt="pie chart placeholder"
            height="100"
            src="/img/pie-chart.svg"
          />
        </div>
      ) : (
        <PieChart width={140} height={168}>
          <Pie
            data={data}
            dataKey="value"
            label={showLabel}
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={52}
          >
            {data.map((_, index) => (
              <Cell key={index} fill={colors[index % colors.length]} />
            ))}
          </Pie>

          {/* if we're not showing the label on the chart then show the count (instead of the %) in the tooltip */}
          <Tooltip content={<CustomTooltip showCount={!showLabel} />} />
        </PieChart>
      )}

      <div className="metrics-pie-chart-labels ml-24" style={{ flex: 1 }}>
        {data.map((data, index) => (
          <div className="flex flex-align-center" key={index}>
            <div
              className="metrics-pie-chart-label-square"
              style={{ background: colors[index % colors.length] }}
            />
            <p>{data.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
